import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import RoutingIcon from '../../../../assets/icons/walker-profile/assets/routing.svg';
import { Box } from '../../../../wag-react/next-components/box';
import { Typography } from '../../../../wag-react/components/Typography';
type Props = {
  distance: number;
};
export const WalkerDistance = ({
  distance
}: Props) => <Box display="flex" alignItems="center" data-sentry-element="Box" data-sentry-component="WalkerDistance" data-sentry-source-file="WalkerDistance.tsx">
    <Image src={RoutingIcon} width={['16px', '18px']} height={['16px', '18px']} alt="Routing icon" data-sentry-element="Image" data-sentry-source-file="WalkerDistance.tsx" />
    <Typography color="#272727" px={1} m="0" fontSize="14px" variant="body2" data-sentry-element="Typography" data-sentry-source-file="WalkerDistance.tsx">
      {distance}
      {' '}
      miles away
    </Typography>
  </Box>;